export default __webpack_public_path__ + "static/media/IMG-20210930-WA0000.359345d5.jpg";